import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

import { Mobile, NotMobile } from "../../../../../hocs/Responsive";
import { RoamingInfo } from "../../../../../components/roamingInfo/RoamingInfo";
import { MobileSortRoamingCounter } from "../../../../home/devices/roamingDeviceTable/components";
import { TableSearch } from "../../../../../components/table/components";
import { RoamingLimitReachedWarning } from "../../../../../components/roamingInfo/RoamingLimitReachedWarning";

export const SingleRoamingDevicesTableHeader = () => {
  return (
    <Fragment>
      <NotMobile>
        <h2 className="roaming-table__title">
          <FormattedMessage id="roaming_devices" />
        </h2>
        <RoamingInfo />
        <TableSearch />
        <RoamingLimitReachedWarning />
      </NotMobile>

      <Mobile>
        <TableSearch />
        <MobileSortRoamingCounter />
        <RoamingLimitReachedWarning />
      </Mobile>
    </Fragment>
  );
};
